var carouselBlockInter = (function () {
  return {
    init: init,
  };

  function init() {
    initSliders();
  }
  function initSliders() {
    var slider = document.querySelector(
      ".bstack-slider.carouse-block-inter__container"
    );

    // show images from lazy load
    if (slider != null) {
      var carousel = slider.querySelector('[data-target="carousel"]'),
        slides = slider.querySelectorAll("[data-target='card']"),
        bullets = slider.querySelectorAll(
          '.bstack-slider-bullets__list-item[role="button"]'
        ),
        sliderMain = slider.querySelector(".bstack-slider__main");

      sliderMainWidth = sliderMain ? sliderMain.scrollWidth : 0;
      carousel.style.width = slider.offsetWidth + "px";
      if (slides.length > 0 && sliderMainWidth > slider.offsetWidth) {
        slider.classList.remove("carouse-block-inter--center-aligned");
        var firstSlide = slides[0],
          lastSlide = slides[slides.length - 1];

        // Set first card as active
        if (firstSlide != null) {
          firstSlide.classList.add("is-active");
          if (firstSlide.nextElementSibling) {
            firstSlide.nextElementSibling.classList.add("is-next");
          }
        }

        // Clone last card and make it as prev
        if (lastSlide) {
          lastSlide.classList.add("is-prev");
        }

        // Behaviour for sliding
        var offsetMain = 0,
          touchstartX = 0,
          touchendX = 0;
        function fnSlide(direction) {
          deactivateSlides();
          var activeSlide = slider.querySelector(
              ".is-active[data-target='card']"
            ),
            prevSlide = slider.querySelector(".is-prev[data-target='card']"),
            nextSlide = slider.querySelector(".is-next[data-target='card']"),
            slides = slider.querySelectorAll("[data-target='card']"),
            lastSlide = slides[slides.length - 2];

          if (direction === "next") {
            offsetMain -= activeSlide.offsetWidth;

            activeSlide.classList.remove("is-active");
            prevSlide.classList.remove("is-prev");
            nextSlide.classList.remove("is-next");

            nextSlide.classList.add("is-active");
            activeSlide.classList.add("is-prev");
            if (nextSlide.nextElementSibling) {
              nextSlide.nextElementSibling.classList.add("is-next");
            }

            setTimeout(function () {
              var clone = activeSlide.cloneNode(true);
              clone.style.transform = "translateX(" + -offsetMain + "px)";
              carousel.append(clone);
              activeSlide.remove();
              slides.forEach(function (sl) {
                sl.style.transform = "translateX(" + -offsetMain + "px)";
              });
              slider.classList.remove('is-slider-loading');
            }, 500);
          } else {
            offsetMain += prevSlide.offsetWidth;

            activeSlide.classList.remove("is-active");
            prevSlide.classList.remove("is-prev");
            nextSlide.classList.remove("is-next");

            activeSlide.classList.add("is-next");
            lastSlide.classList.add("is-prev");

            // Removing the last element and cloning it to the start
            if (prevSlide) {
              var clone = prevSlide.cloneNode(true);
              clone.classList.add("is-active");
              clone.style.transform = "translateX(" + -offsetMain + "px)";
              carousel.prepend(clone);
            }

            slides.forEach(function (sl) {
              sl.style.transform = "translateX(" + -offsetMain + "px)";
            });

            setTimeout(function () {
              prevSlide.remove();
              slider.classList.remove('is-slider-loading');
            }, 500);
          }
          carousel.style.transform = "translateX(" + offsetMain + "px)";
          getActiveSlide = document.querySelector(
            ".is-active[data-target='card']"
          );

          if (bullets.length > 0 && getActiveSlide != null) {
            var slideIndex = getActiveSlide.getAttribute("data-slide");

            activateBullet(bullets[slideIndex]);
          }
          // Lazy loading
          var lazyLoadingInitCount =0,lazyLoadingInit = setInterval(function () {
            lazyLoadingInitCount++
            if (lazyLoadingInit && lazyLoadingInitCount > 6) {
              clearInterval(lazyLoadingInit)
            } 
            lazyLoading.show();
          },100)
        }

        //activate corresponding bullet
        function activateBullet(bullet) {
          var activeBullet = document.querySelector(
            '.bstack-slider-bullets__list-item[aria-selected="true"]'
          );
          if (activeBullet) {
            activeBullet.setAttribute("aria-selected", "false");
          }

          bullet.setAttribute("aria-selected", "true");
          bullet.setAttribute("tabindex", "-1");
          bullet.parentElement.classList.add(
            "bstack-slider-bullets__list--active"
          );
        }

        function deactivateSlides() {
          bullets.forEach(function (bullet) {
            bullet.setAttribute("aria-selected", "false");
            bullet.removeAttribute("tabindex", "1");
            bullet.parentElement.classList.remove(
              "bstack-slider-bullets__list--active"
            );
          });
        }

        // Nav buttons
        var leftSlideBtn = slider.querySelector('[data-action="slideLeft"]'),
          rightSlideBtn = slider.querySelector('[data-action="slideRight"]');

        if (leftSlideBtn != null) {
          leftSlideBtn.addEventListener("click", function () {
            slider.classList.add('is-slider-loading');
            fnSlide("prev");
          });
        }
        if (rightSlideBtn != null) {
          rightSlideBtn.addEventListener("click", function () {
            slider.classList.add('is-slider-loading');
            fnSlide("next");
          });
        }

        //touch swipe
        carousel.addEventListener(
          "touchstart",
          function (e) {
            touchstartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );

        carousel.addEventListener(
          "touchend",
          function (e) {
            touchendX = e.changedTouches[0].screenX;
            //swipe left
            if (touchendX > touchstartX) {
              fnSlide("prev");
            }

            //swipe right
            if (touchendX < touchstartX) {
              fnSlide("next");
            }
          },
          { passive: true }
        );

        //SlideTo

        function fnSlideTo(slideToIndex) {

          deactivateSlides();
          var activeSlide = slider.querySelector(
              ".is-active[data-target='card']"
            ),
            prevSlide = slider.querySelector(".is-prev[data-target='card']"),
            nextSlide = slider.querySelector(".is-next[data-target='card']"),
            slides = slider.querySelectorAll("[data-target='card']"),
            loopCloned = [],
            firstSlide = slides[0],
            lastSlide = slides[slides.length - 1];
          if (isNaN(slideToIndex) == false) {
            var prevSlideIndex = slideToIndex - 1;
            if (isNaN(slideToIndex) == false && slideToIndex == 0) {
              prevSlideIndex = slides.length - 1;
            }
            var prevSlideNew = slider.querySelector(
              '[data-slide="' + prevSlideIndex + '"]'
            );
            var nextSlideIndex = slideToIndex + 1;
            if (slideToIndex == slides.length - 1) {
              nextSlideIndex = 0;
            }
            nextSlideNew = slider.querySelector(
              '[data-slide="' + nextSlideIndex + '"]'
            );

            prevSlideOffset = prevSlideNew ? prevSlideNew.offsetWidth : 0;
            activeSlideIndex = parseInt(activeSlide.dataset.slide);
            currentSlide = slider.querySelector(
              '[data-slide="' + slideToIndex + '"]'
            );
            if (activeSlideIndex != slideToIndex) {
              activeSlide.classList.remove("is-active");
              prevSlide.classList.remove("is-prev");
              nextSlide.classList.remove("is-next");

              prevSlideNew.classList.add("is-prev");
              if (slideToIndex > activeSlideIndex) {
                if (slideToIndex - activeSlideIndex == 1) {
                  offsetMain -= prevSlideOffset;
                  var clone = prevSlideNew.cloneNode(true);
                  loopCloned.push(prevSlideNew);
                  carousel.append(clone);
                }
                //
                if (slideToIndex - activeSlideIndex > 1) {
                  for (
                    activeSlideIndex;
                    activeSlideIndex < slideToIndex;
                    activeSlideIndex++
                  ) {
                    var loopSlide = slider.querySelector(
                      '[data-slide="' + activeSlideIndex + '"]'
                    );
                    offsetMain -= loopSlide.offsetWidth;

                    if (
                      slideToIndex == slides.length - 1 &&
                      activeSlideIndex == 0
                    ) {
                      loopSlide.classList.add("is-next");
                    }
                    var clone = loopSlide.cloneNode(true);
                    loopCloned.push(loopSlide);
                    carousel.append(clone);
                  }
                }

                currentSlide.classList.add("is-active");
                if (currentSlide.nextElementSibling) {
                  currentSlide.nextElementSibling.classList.add("is-next");
                }
                setTimeout(function () {
                  loopCloned.forEach(function (e) {
                    e.remove();
                  });
                  slider.classList.remove('is-slider-loading');
                  document
                    .querySelectorAll(
                      ".bstack-slider.carouse-block-inter__container .bstack-slider__slide[data-target='card']"
                    )
                    .forEach(function (sl) {
                      sl.style.transform = "translateX(" + -offsetMain + "px)";
                    });
                }, 500);
              } else {
                currentSlide.classList.add("is-active");
                if (nextSlideNew) {
                  nextSlideNew.classList.add("is-next");
                }
                offsetMain += prevSlide.offsetWidth;
                //
                if (activeSlideIndex - slideToIndex > 1) {
                  var i = activeSlideIndex - 1;
                  for (i; i >= slideToIndex; i--) {
                    var loopSlide = slider.querySelector(
                      '[data-slide="' + i + '"]'
                    );

                    if (loopSlide != null) {
                      var clone = loopSlide.cloneNode(true);
                      loopCloned.push(loopSlide);
                      carousel.prepend(clone);
                    }
                  }
                } else {
                  var clone = lastSlide.cloneNode(true);
                  loopCloned.push(lastSlide);
                  carousel.prepend(clone);
                }
                document
                  .querySelectorAll(
                    ".bstack-slider.carouse-block-inter__container .bstack-slider__slide[data-target='card']"
                  )
                  .forEach(function (sl) {
                    sl.style.transform = "translateX(" + -offsetMain + "px)";
                  });
                setTimeout(function () {
                  loopCloned.forEach(function (e) {
                    e.remove();
                  });
                  slider.classList.remove('is-slider-loading');
                }, 500);
              }
            }
          }
          carousel.style.transform = "translateX(" + offsetMain + "px)";

          getActiveSlide = document.querySelector(
            ".is-active[data-target='card']"
          );

          if (bullets.length > 0 && getActiveSlide != null) {
            var slideIndex = parseInt(getActiveSlide.dataset.slide);

            activateBullet(bullets[slideIndex]);
          }
          // Lazy loading
          lazyLoading.show();
        }

        bullets.forEach(function (bullet, index) {
          bullet.addEventListener("click", function (e) {
            e.target;
            slider.classList.add('is-slider-loading');
            deactivateSlides();

            fnSlideTo(index);
          });
        });
      } else {
        slider.classList.add("carouse-block-inter--center-aligned");
      }
    }
  }
})();

window.addEventListener("load", function () {
  carouselBlockInter.init();
});
